export interface TwoFactorType {
    enable: boolean;
    factorType: "GA" | "SMS";
};